import React, { Component } from 'react';
import SimpleReactValidator from 'simple-react-validator';

import ExpenseTypePage from './expense-types-html';
import { expenseServices } from '../../../../../../../../_services';
import { toast } from 'react-toastify';
import { alertConstants } from '../../../../../../../../_constants/alert.constants';
import $ from 'jquery';
class ExpenseType extends Component {
    constructor(props) {
        super(props)
        window.scrollTo({ top: 0, behavior: 'smooth' })
        this.validator = new SimpleReactValidator();
        this.state = {
            companyId: localStorage['440a28'],
            loading:true,
        } 
    }
    pageItemsList = [{ items: 10 }, { items: 20 }, { items: 30 }];
    activePage = 1;
    itemsPerPage = 10;
    search = '';
    listExpenseTypes = [];
    choosedItem = '';
    componentDidMount() {
        this.getExpenseTypes()
    } 
    getExpenseTypes = async () => {
        this.listExpenseTypes = [];
        this.count = 0;
        this.choosedItem = ''
        this.setState({loading:true})
        var resp = await expenseServices.getExpenseTypes(this.activePage, this.itemsPerPage, this.search, this.state.companyId)
        if (resp) {
            this.count = resp.count
            this.listExpenseTypes = resp.result;
        } 
        this.setState({loading:false})
    }
    handleChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        })
    }
    handleSearch = (e) => {
        this.search = e.target.value;
        this.getExpenseTypes() 
    }
    handleItemChange = (limit) => {
        this.activePage = 1;
        this.itemsPerPage = limit['items'];
        this.getExpenseTypes(); 
    }
    handlePageChange = (pageNumber) => {
        this.activePage = pageNumber
        this.getExpenseTypes(); 
    }
    handleStatusChange = async (data) => {
        let newStatus = !data.activeStatus;
        let payload = {
            activeStatus: newStatus
        }
        var resp = await expenseServices.statusExpenseTypes(data.id, payload)
        toast.info(resp.message)
        this.getExpenseTypes()
    } 
    chooseEdit = (e) => {
        (e === this.choosedItem) ? this.choosedItem = '' : this.choosedItem = e
        this.setState({...this.state})
    }
    removeItem = async (e) => {
        var resp = await expenseServices.deleteExpenseTypes(this.choosedItem)
        if (resp) {
            toast.info(resp.message)
            this.getExpenseTypes()
        }
    }
    getData = () => {
        this.listExpenseTypes.forEach(item =>{
            if(item.id === this.choosedItem){
                this.setState(
                    {expenseTypeName:item.expenseTypeName}
                )
            }
        })
    }

    render() {
        return (
            <div>
                <ExpenseTypePage
                    validator={this.validator}
                    state={this.state}
                    loading={this.state.loading}
                    handleChange={this.handleChange}
                    addSubmit={this.addSubmit}
                    listExpenseTypes={this.listExpenseTypes}
                    activePage={this.activePage}
                    itemsPerPage={this.itemsPerPage}
                    handleSearch={this.handleSearch}
                    pageItemsList={this.pageItemsList}
                    handleItemChange={this.handleItemChange}
                    count={this.count}
                    choosedItem={this.choosedItem}
                    chooseEdit={this.chooseEdit}
                    handleStatusChange={this.handleStatusChange}
                    removeItem={this.removeItem}
                    editSubmit={this.editSubmit}
                    close={this.close}
                    getData={this.getData}
                    handlePageChange={this.handlePageChange}
                />
            </div>
        )
    }
}
export default ExpenseType;